export function toLocalDate(startDate) {
    return `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;
}

export function toLocalDateReversed(startDate) {
    return `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`;
}

export function getDateStringToAvoidTimezone(value) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function formatDateTime(date, hour) {
    const newDate = new Date(date);

    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const year = newDate.getFullYear();

    let formattedTime = null;
    if(hour !== null) {
        formattedTime = hour.substring(0, 5);
    }

    return `${day}-${month}-${year} ${formattedTime}`;
}

export function formatDate(date) {
    if(!date) {
        return '';
    }

    const newDate = new Date(date);

    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const year = newDate.getFullYear();

    return `${day}-${month}-${year}`;
}

export function formatHour(hour) {
    let formattedHour = null;
    if(hour !== null) {
        formattedHour = hour.substring(0, 5);
    }

    return formattedHour;
}

export function formatDateTimeByDate(date) {
    return formatDate(date) + ' ' + formatHour(date);
}

// Formats a Date or ISO string into local time: dd-MM-yyyy HH:mm
export function formatDateTimeLocal(value) {
    if (!value) return '';

    const d = new Date(value);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
}

export function parseFormattedDate(dateStr) {
    if (!dateStr) return null;

    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);

    // If time is "null", treat it as '00:00'
    const [hours, minutes] = (timePart && timePart !== "null") ? timePart.split(':').map(Number) : [0, 0];

    return new Date(year, month - 1, day, hours, minutes);
}

export const isWeekendDay = date => date.getDay() % 6 === 0;

// Formats an ISO string or Date into HH:mm in local time
export function formatIsoToHHMM(iso) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false});
    } catch (e) {
        return '';
    }
}
